import { render, staticRenderFns } from "./AttributsReorder.vue?vue&type=template&id=4f818931&scoped=true"
import script from "./AttributsReorder.vue?vue&type=script&lang=js"
export * from "./AttributsReorder.vue?vue&type=script&lang=js"
import style0 from "./AttributsReorder.vue?vue&type=style&index=0&id=4f818931&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f818931",
  null
  
)

export default component.exports